import Phaser from 'phaser';

const BG_OUTER = 0x1f0f0f;
const BG_INNER = 0x450a0a;
const BODY_COLOR = 0xd1d5db;
const BODY_EDGE = 0x4b5563;
const FLAME = 0xfb923c;
const FLAME_HOT = 0xfde047;
const STROKE = 0x0a0f1f;

export function drawBlaster(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const gripW = r * 0.25;
  const gripH = r * 0.55;
  const gripX = -r * 0.35;
  const gripY = r * 0.05;

  g.fillStyle(BODY_COLOR, 1);
  g.lineStyle(Math.max(1, Math.floor(stroke * 0.7)), BODY_EDGE, 1);
  g.fillRoundedRect(gripX, gripY, gripW, gripH, 2);
  g.strokeRoundedRect(gripX, gripY, gripW, gripH, 2);

  const barrelX = gripX + gripW * 0.3;
  const barrelY = gripY - r * 0.2;
  const barrelW = r * 0.95;
  const barrelH = r * 0.32;
  g.fillStyle(BODY_COLOR, 1);
  g.fillRoundedRect(barrelX, barrelY, barrelW, barrelH, 3);
  g.strokeRoundedRect(barrelX, barrelY, barrelW, barrelH, 3);

  const scopeX = barrelX + barrelW * 0.4;
  const scopeY = barrelY - r * 0.12;
  const scopeW = r * 0.3;
  const scopeH = r * 0.18;
  g.fillStyle(BODY_EDGE, 1);
  g.fillRoundedRect(scopeX, scopeY, scopeW, scopeH, 2);
  g.strokeRoundedRect(scopeX, scopeY, scopeW, scopeH, 2);

  const flameTipX = barrelX + barrelW + r * 0.35;
  const flameBaseX = barrelX + barrelW;
  const flameY = barrelY + barrelH / 2;
  g.fillStyle(FLAME, 1);
  g.lineStyle(2, 0xdc2626, 1);
  g.beginPath();
  g.moveTo(flameBaseX, flameY - r * 0.14);
  g.lineTo(flameTipX, flameY);
  g.lineTo(flameBaseX, flameY + r * 0.14);
  g.closePath();
  g.fillPath();
  g.strokePath();

  g.fillStyle(FLAME_HOT, 0.85);
  g.beginPath();
  g.moveTo(flameBaseX + r * 0.08, flameY - r * 0.07);
  g.lineTo(flameBaseX + r * 0.25, flameY);
  g.lineTo(flameBaseX + r * 0.08, flameY + r * 0.07);
  g.closePath();
  g.fillPath();
}
